export default "__VITE_ASSET__pPoNIWsx__"